import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useNavigate } from "react-router-dom";
import { useState } from 'react';
import { DEMO_POPUP_TYPES } from "../../../common/utility/constant.js"
import { useAxiosWithAuth } from '../../../common/api/hooks/useAxiosWithAuth.js';
import { URL } from '../../../common/api/urls.js';
import { DEMO_MESSAGES } from '../../../common/utility/demo_messages.js';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: { xs: '90%', sm: '500px' },
  maxWidth: '500px',
  bgcolor: '#ffffff',
  borderRadius: '20px',
  padding: '30px',
  boxShadow: '0 25px 50px rgba(0, 0, 0, 0.3)',
  animation: 'slideIn 0.5s ease',
  '@keyframes slideIn': {
    from: {
      opacity: 0,
      transform: 'translate(-50%, -60%) scale(0.9)'
    },
    to: {
      opacity: 1,
      transform: 'translate(-50%, -50%) scale(1)'
    }
  }
};

export default function OfDemoPopup(props) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(props.open);
  const [cancelUpdate,responseUpdate, errorUpdate, loadedUpdate, resetUpdate,executeAPIUpdate ] = useAxiosWithAuth();
  const [content, setContent] = useState(null);

  const handleClose = () => {
    setOpen(false);
    props.onClose();
  };

  React.useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  // Recalculate content whenever props change
  React.useEffect(() => {
    const newContent = getPopupContent(props.demoType, props.demoIndex, props.hasOfferTr);
    // console.log('🔄 Content updated:', { demoType: props.demoType, demoIndex: props.demoIndex, contentId: newContent.id });
    setContent(newContent);
  }, [props.demoType, props.demoIndex, props.hasOfferTr]);

  React.useEffect(() => {
    if (open) {
      executeAPIUpdate(URL.UPDATE_DEMO_NOTIFICATION_TIME, "POST", { symbol: "NIFTY" });
    }
  }, [open]);


  const handleStartDemoAction = () => {
    setOpen(false);
    props.onClose();
    props.onDemoStart();
  };

  const handleSubscribeAction = () => {
    props.onClose();
    // DEMO_COMPLETED popup with offer (_tr) navigates to /landing, without offer goes to /subscription
    if (props.demoType === DEMO_POPUP_TYPES.DEMO_COMPLETED && props.hasOfferTr) {
      navigate('/landing');
    } else {
      navigate('/subscription');
    }
  };

  const handleCloseAction = () => {
    props.onClose();
  };

  const getPopupContent = (demoType, demoIndex, hasOfferTr) => {
    const finalDemoType = demoType || DEMO_POPUP_TYPES.NEW_USER;
    const finalDemoIndex = demoIndex !== undefined ? demoIndex : undefined;

    // console.log('🔍 getPopupContent Debug:', {
    //   demoType: finalDemoType,
    //   demoIndex: finalDemoIndex,
    //   DEMO_MESSAGES_0_ID: DEMO_MESSAGES[0]?.id,
    //   DEMO_MESSAGES_0_HOUR: DEMO_MESSAGES[0]?.hour
    // });

    if (finalDemoType && finalDemoType !== undefined) {
      if (finalDemoType === DEMO_POPUP_TYPES.NEW_USER) {
        return {
          id: 0,
          hour: "HOUR 0 - NEW USER",
          title: "Orderflow Demo Free!",
          content: "Access our Orderflow charts and proprietary tools with live data feed straight from NSE. Subscribe now for a 2-day free trial!",
          tip: {
            heading: "Quick Tip:",
            content: "Make the most of your 2-day trial by exploring all features right away."
          },
          subcontent: {
            heading: "What You Get:",
            content: "Live data feed, Orderflow charts, and proprietary tools designed for elite trading."
          },
          primaryButton: "Start Trial",
          secondaryButton: "Got It"
        };
      }

      if (finalDemoType === DEMO_POPUP_TYPES.DEMO_ACTIVE && finalDemoIndex !== undefined && finalDemoIndex < DEMO_MESSAGES.length) {
      
        return {
          id: DEMO_MESSAGES[finalDemoIndex].id,
          hour: DEMO_MESSAGES[finalDemoIndex].hour,
          title: DEMO_MESSAGES[finalDemoIndex].title,
          content: DEMO_MESSAGES[finalDemoIndex].content,
          tip: {
            heading: DEMO_MESSAGES[finalDemoIndex].tip.heading,
            content: DEMO_MESSAGES[finalDemoIndex].tip.content
          },
          subcontent: {
            heading: DEMO_MESSAGES[finalDemoIndex].subcontent.heading,
            content: DEMO_MESSAGES[finalDemoIndex].subcontent.content
          },
          primaryButton: DEMO_MESSAGES[finalDemoIndex].action,
          secondaryButton: "Got It"
        };
      }

      if (finalDemoType === DEMO_POPUP_TYPES.DEMO_COMPLETED) {
        return {
          id: 13,
          hour: "HOUR 13 - DEMO COMPLETED",
          title: "Demo Completed",
          content: "Your 2-day demo has ended. Don't miss out on the full experience—subscribe now to continue accessing our Orderflow charts and proprietary tools with live data feed straight from NSE.",
          tip: {
            heading: "Pro Tip:",
            content: "Subscribing now ensures uninterrupted access to elite tools."
          },
          subcontent: {
            heading: "Next Step:",
            content: "Choose a subscription plan that fits your trading style and stay ahead."
          },
          discountMessage: hasOfferTr ? "Limited time offer - Get 35% discount on Elite plans - Upgrade before the offer expires" : undefined,
          primaryButton: "Upgrade Now",
          secondaryButton: "Not Now"
        };
      }

    }
    
   
    // Default fallback content
    return {
      id: 12,
      hour: "HOUR 12 - FINAL COUNTDOWN",
      title: "🚨 Final Countdown",
      content: "Your Elite demo ends soon. Keep your edge alive—upgrade now.",
      tip: {
        heading: "🎯 Don't Lose Your Edge:",
        content: "You've experienced trading with institutional-grade tools. Going back to basic charts after this would be like racing with a blindfold."
      },
      subcontent: {
        heading: "The Choice is Yours:",
        content: "Continue with Elite's professional tools, or return to guessing. You know what professional traders choose."
      },
      primaryButton: "Upgrade to Elite",
      secondaryButton: "Got It"
    };
  };


  return (
    <>
      {content && (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="demo-modal-title"
          aria-describedby="demo-modal-description"
          sx={{
          '& .MuiBackdrop-root': {
            backgroundColor: props.demoType === DEMO_POPUP_TYPES.DEMO_COMPLETED
              ? 'rgba(30, 60, 114, 0.6)' 
              : 'rgba(0, 0, 0, 0.8)',
            backdropFilter: 'blur(8px)',
            animation: 'fadeIn 0.4s ease',
            '@keyframes fadeIn': {
              from: { opacity: 0 },
              to: { opacity: 1 }
            }
          }
        }}
      >
        <Box sx={style}>
          {/* Hour Badge */}
          {content.id && (
            <Box sx={{
              background: (() => {
                // Hours 1-6: Primary blue gradient (low/medium urgency)
                if (content.id >= 1 && content.id <= 6) {
                  return 'linear-gradient(135deg, #1e3c72, #2a5298)';
                }
                // Hours 7-11: Warning red gradient (high urgency)
                else if (content.id >= 7 && content.id <= 11) {
                  return 'linear-gradient(135deg, #ff6b6b, #ee5a24)';
                }
                // Hour 12: Critical urgency (more intense red)
                else if (content.id === 12) {
                  return 'linear-gradient(135deg, #ff4757, #c44569)';
                }
                // Default: Primary blue
                else {
                  return 'linear-gradient(135deg, #1e3c72, #2a5298)';
                }
              })(),
              color: '#ffffff',
              padding: '8px 20px',
              borderRadius: '25px',
              fontSize: '14px',
              fontWeight: '600',
              display: 'inline-block',
              marginBottom: '20px',
              textAlign: 'center',
              width: 'fit-content',
              boxShadow: content.id === 12 
                ? '0 4px 15px rgba(255, 71, 87, 0.4)' 
                : '0 2px 10px rgba(0,0,0,0.2)'
            }}>
    {content.hour?.split(' - ')[1] || 'ELITE DEMO'}
            </Box>
          )}

          {/* Title */}
          <Typography 
            id="demo-modal-title" 
            variant="h4" 
            component="h2"
            sx={{
              fontSize: '24px',
              fontWeight: '700',
              color: '#333333',
              marginBottom: '15px',
              textAlign: 'center',
              lineHeight: '1.2'
            }}
          >
            {content.title}
          </Typography>

          {/* Main Content */}
          <Typography 
            sx={{ 
              color: '#555555',
              lineHeight: '1.6',
              marginBottom: '20px',
              fontSize: '14px'
            }}
          >
            {content.content}
          </Typography>

          {/* Tip Box */}
          {content.tip && (
            <Box sx={{
              background: 'linear-gradient(135deg, #f8f9ff, #e8f0ff)',
              borderLeft: '4px solid #667eea',
              padding: '20px',
              borderRadius: '10px',
              margin: '20px 0'
            }}>
              <Typography 
                variant="subtitle1" 
                sx={{ 
                  fontWeight: '600', 
                  color: '#333333',
                  marginBottom: '10px',
                  fontSize: '14px'
                }}
              >
                {content.tip.heading}
              </Typography>
              <Typography 
                sx={{ 
                  color: '#555555',
                  lineHeight: '1.6',
                  fontSize: '14px'
                }}
              >
                {content.tip.content}
              </Typography>
            </Box>
          )}

          {/* Subcontent */}
          {content.subcontent && (
            <Box sx={{
              background: 'rgba(102, 126, 234, 0.05)',
              padding: '15px',
              borderRadius: '8px',
              margin: '15px 0'
            }}>
              <Typography 
                variant="subtitle1" 
                sx={{ 
                  fontWeight: '600', 
                  color: '#333333',
                  marginBottom: '8px',
                  fontSize: '14px'
                }}
              >
                {content.subcontent.heading}
              </Typography>
              <Typography 
                sx={{ 
                  color: '#555555',
                  lineHeight: '1.6',
                  fontSize: '14px'
                }}
              >
                {content.subcontent.content}
              </Typography>
            </Box>
          )}

          {/* Discount Message */}
          {content.discountMessage && (
            <Typography 
              sx={{ 
                color: '#6e430e',
                lineHeight: '1.6',
                marginTop: '20px',
                marginBottom: '10px',
                fontSize: '14px',
                fontWeight: '600',
                textAlign: 'center'
              }}
            >
              {content.discountMessage}
            </Typography>
          )}

          {/* Action Buttons */}
          <Box sx={{ 
            marginTop: '30px', 
            display: 'flex', 
            gap: '15px', 
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'center'
          }}>
            <Button
              variant="contained"
              onClick={props.demoType === DEMO_POPUP_TYPES.NEW_USER ? handleStartDemoAction : handleSubscribeAction}
              sx={{
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                color: '#ffffff',
                padding: '12px 25px',
                border: 'none',
                borderRadius: '25px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                flex: 1,
                fontSize: '14px',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 20px rgba(102, 126, 234, 0.3)',
                  background: 'linear-gradient(135deg, #5a6fd8, #6a4190)'
                }
              }}
            >
              {content.primaryButton}
            </Button>

            <Button
              variant="outlined"
              onClick={handleCloseAction}
              sx={{
                background: 'transparent',
                color: '#667eea',
                border: '2px solid #667eea',
                padding: '12px 25px',
                borderRadius: '25px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                flex: 1,
                fontSize: '14px',
                '&:hover': {
                  background: '#667eea',
                  color: '#ffffff',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 20px rgba(102, 126, 234, 0.3)'
                }
              }}
            >
              {content.secondaryButton}
            </Button>
          </Box>
        </Box>
      </Modal>
      )}
    </>
  );
}